import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';

interface ActionBoxProps {
    imgPath: string;
    linkTo: string;
    boxMessage: string;
}

export function ActionBox(props: ActionBoxProps) {
    const {t} = useTranslation();

    return (
            <Link to={props.linkTo} style={{textDecoration: 'none'}} className="m-[5px] tablet:m-[8px] rounded-lg shadow-md bg-[#21262B] flex flex-col">
                <img
                    alt={props.boxMessage}
                    src={props.imgPath}
                    style={{width: '100%', borderRadius: '8px 8px 0 0'}}
                />
                <div className="px-[5px] tablet:px-[16px] pt-[9px] tablet:pt-[16.67px] pb-[20px] tablet:pb-[22.76px] h-full flex flex-col">
                    <div className="font-medium text-[10px] tablet:text-[18px] desktop:text-[20px] tracking-[0.417px]">{props.boxMessage}</div>
                    <div className="mt-auto pt-[6px] tablet:pt-[13px] notebook:pt-[36.2px]">
                        <button className="w-full h-[20px] tablet:h-[27px] notebook:h-[36px] border border-[#7E8184] rounded-[4px] tablet:rounded-[8px] bg-[#21262B] hover:bg-[#32373C] text-[#ECECEE] text-[12px] font-normal tablet:text-[14px] notebook:text-[16px]">
                            {t('home.actionBox.showButton')}
                        </button>
                    </div>
                </div>
            </Link>
    );
}
